// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"51c565a4","429":"1851ad0c","438":"1151a95f","637":"70ac5ee9"}[chunkId] + ".chunk.css";
};